import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const TestsLiteracy = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.literacy}
        />
    );
};

export default TestsLiteracy;
